import React from "react";
import { useContext } from "react";
import { LanguageContext } from "./LanguageContext";

const VapingEducativo = ({ getStyles, theme }) => {
  const { t } = useContext(LanguageContext);

  return (
     <div id="educativo" style={getStyles(theme).content}>
      <h2 style={getStyles(theme).sectionTitle}>{t("vapingEducativo")}</h2>

      <div style={getStyles(theme).section}>
        <h3 style={getStyles(theme).subSectionTitle}>{t("usoResponsabile")}</h3>
        <p>{t("usoResponsabileContent")}</p>
      </div>

      <div style={getStyles(theme).section}>
        <h3 style={getStyles(theme).subSectionTitle}>{t("usoNicotina")}</h3>
        <p>{t("usoNicotinaContent")}</p>
      </div>

      <div style={getStyles(theme).section}>
        <h3 style={getStyles(theme).subSectionTitle}>
          {t("smettereDiscutetere")}
        </h3>
        <p>{t("smettereDiscutetereContent")}</p>
      </div>

      <div style={getStyles(theme).section}>
        <h3 style={getStyles(theme).subSectionTitle}>{t("faq")}</h3>
        <ul>
          {t("faqList").map((item, index) => (
            <li key={index}>
              <strong>{item.q}</strong> {item.a}
            </li>
          ))}
        </ul>
      </div>

      <div style={getStyles(theme).section}>
        <h3 style={getStyles(theme).subSectionTitle}>
          {t("beneficiSmettere")}
        </h3>
        <ul>
          {t("beneficiSmettereList").map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>

      <div style={getStyles(theme).section}>
        <h3 style={getStyles(theme).subSectionTitle}>{t("mitiEFatti")}</h3>
        <ul>
          {t("mitiEFattiList").map((item, index) => (
            <li key={index}>
              <strong>{item.mito}</strong> {item.fatto}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default VapingEducativo;
